import { useEffect, useRef, useState } from 'react';

export default function useIdleLogout({ onLogout, isAuthed, idleTime = 60 * 60 * 1000, warningTime = 10 * 1000 }) {
  const logoutTimer = useRef(null);
  const warningTimer = useRef(null);
  const [showWarning, setShowWarning] = useState(false);

  const resetTimers = () => {
    clearTimeout(logoutTimer.current);
    clearTimeout(warningTimer.current);
    setShowWarning(false);

    warningTimer.current = setTimeout(() => {
      setShowWarning(true);
    }, idleTime - warningTime);

    logoutTimer.current = setTimeout(() => {
      onLogout();
    }, idleTime);
  };

  useEffect(() => {
    const isStaging = window.location.hostname.includes("staging") || window.location.hostname.includes("localhost");
    if (!isStaging || !isAuthed) return;

    resetTimers();

    const events = ['mousemove', 'keydown', 'click'];
    events.forEach((event) => window.addEventListener(event, resetTimers));

    return () => {
      clearTimeout(logoutTimer.current);
      clearTimeout(warningTimer.current);
      events.forEach((event) => window.removeEventListener(event, resetTimers));
    };
  }, [isAuthed]); // 👈 now reacts to login status

  return { showWarning, cancelWarning: resetTimers };
}